/* non eslint-disable  */
import { FC, useState, MouseEvent, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Table, Button as Button2 } from 'antd';
import 'antd/dist/antd.css';
import './Page.css';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ClientSearchPanel from 'components/molecules/ClientSearchPanel';
import { SearchUserConditions, UserListModel } from 'types/User';
import { RecieptType } from 'types/RecieptType';
import { rootDir } from 'utils/CommonConst';
import { AppContext } from 'utils/AppContext';
import CustomBackdrop from 'components/molecules/CustomBackdrop';
import { RequestSearchConditions } from 'types/RequestSearchConditions';
import HeaderTemplate from '../templates/HeaderTemplate';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginTop: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      fontSize: '18px',
    },
  }),
);

export type ClientSearchPanelProps = {
  title?: string;
};

const ClientSearchPage: FC<ClientSearchPanelProps> = ({ title = '' }) => {
  const appContext = useContext(AppContext);
  const classes = useStyles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open2 = Boolean(anchorEl);
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState<UserListModel[]>([]);
  const [recieptTypes, setRecieptTypes] = useState<RecieptType[]>([]);
  const [idCust, setIdCust] = useState(0);
  const [isNoAccount, setIsNoAccount] = useState(false);
  const [defaultPage, setDefaultPage] = useState<number | undefined>(1);
  const [searchCondition, setSearchCondition] =
    useState<SearchUserConditions>();
  const location = useLocation();
  const { recSearchCondition, currentPage } = (location.state as {
    recSearchCondition: SearchUserConditions | undefined;
    currentPage: number | undefined;
  }) || {
    recSearchCondition: undefined,
    currentPage: undefined,
  };

  useEffect(() => {
    if (appContext.state.LoginUser.isLogin) {
      if (!appContext.state.LoginUser.isMaster) {
        // 管理者専用ページのため
        navigate(`${rootDir}top`);
      }
    }
  }, [appContext.state.LoginUser, navigate]);

  useEffect(() => {
    if (currentPage !== undefined) {
      setDefaultPage(currentPage);
    }
  }, [currentPage]);

  const handleMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      title: '顧客番号',
      dataIndex: 'custData',
      key: 'custData',
      width: 150,
      align: 'center' as const,
    },
    {
      title: '顧客名',
      dataIndex: 'custName',
      key: 'custName',
      render: (value: string, record: UserListModel) => (
        // eslint-disable-next-line
        <a
          onClick={() => {
            navigate(`${rootDir}accountMaster`, {
              state: {
                idCust: record.idCust,
                searchCondition,
                currentPage: defaultPage,
              },
            });
          }}
        >
          {value}
        </a>
      ),
      align: 'center' as const,
    },
    {
      title: '住所',
      align: 'center' as const,
      render: (_value: string, record: UserListModel) =>
        `${record.address1} ${record.address2}`,
    },
    {
      title: '依頼件数',
      dataIndex: 'recieptCount',
      key: 'recieptCount',
      width: 150,
      render: (value: string, record: UserListModel) => (
        // eslint-disable-next-line
        <a
          onClick={() => {
            const conditions: RequestSearchConditions = {
              custData: record.custData,
              custName: '',
              sRcptCreate: '',
              eRcptCreate: '',
              recieptType: null,
              process: null,
              mesItem: '',
              nameSampleIndex: '',
              pic: '',
              isMaster: appContext.state.LoginUser.isMaster,
              idCust: appContext.state.LoginUser.idCust,
            };
            navigate(`${rootDir}requestSearch`, {
              state: {
                recSearchCondition: conditions,
              },
            });
          }}
        >
          {value}
        </a>
      ),
      align: 'center' as const,
    },
    {
      title: '月次請求書',
      dataIndex: 'chargeCount',
      key: 'chargeCount',
      width: 150,
      render: (value: string, record: UserListModel) => {
        if (record.isMonthlyInvoice && record.isWeb) {
          return (
            /* eslint-disable  */
            <>
              <a
                onClick={() => {
                  navigate(`${rootDir}invoiceUpload`, {
                    state: {
                      idCust: record.idCust,
                      searchCondition,
                      currentPage: defaultPage,
                    },
                  });
                }}
              >
                {value}
              </a>
            </>
            /* eslint-enable  */
          );
        }

        return '－';
      },
      align: 'center' as const,
    },
    {
      title: '月次請求設定',
      dataIndex: 'billingInfo',
      key: 'billingInfo',
      width: 150,
      render: (value: string, record: UserListModel) => (
        /* eslint-disable  */
        <>
          <Button2
            onClick={() => {
              navigate(`${rootDir}billingInfo`, {
                state: {
                  idCust: record.idCust,
                  searchCondition,
                  currentPage: defaultPage,
                },
              });
            }}
            type="primary"
          >
            設定
          </Button2>
        </>
        /* eslint-enable  */
      ),
      align: 'center' as const,
    },
    {
      title: '代理依頼申込',
      dataIndex: 'application',
      key: 'application',
      width: 150,
      render: (_value: string, record: UserListModel) => (
        <div className="clientSearch-button">
          <Button2
            onClick={(e) => {
              setIdCust(record.idCust);
              setIsNoAccount(record.loginID === '');
              handleMenu(e);
            }}
            type="primary"
          >
            依頼申込
          </Button2>
          <Menu
            id="application"
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={open2}
            onClose={handleClose}
          >
            {recieptTypes
              ?.filter((x) => x.id !== 0)
              .map((item) => (
                <MenuItem
                  key={item.menuTitle}
                  value={`${item.id}`}
                  onClick={() => {
                    navigate(`${rootDir}requestInfo`, {
                      state: {
                        id: null,
                        idCust,
                        recieptType: item.id,
                        isNoAccount,
                      },
                    });
                    handleClose();
                  }}
                >
                  {item.menuTitle}
                </MenuItem>
              ))}
          </Menu>
        </div>
      ),
      align: 'center' as const,
    },
  ];

  return (
    <HeaderTemplate title="顧客検索">
      <Container component="main" maxWidth="xl">
        <div className={classes.paper}>
          <Typography component="h5" variant="h4">
            {title}
          </Typography>
          <ClientSearchPanel
            setsearchCondition={setSearchCondition}
            setResult={setUserData}
            setIsLoading={setIsLoading}
            setRecieptTypes={setRecieptTypes}
            defaultSearchCondition={recSearchCondition}
          />
          <div className="table-size" hidden={isLoading}>
            <Table
              dataSource={userData}
              columns={columns}
              rowKey="idCust"
              pagination={{ pageSize: 10, defaultCurrent: currentPage }}
              onChange={(data) => {
                // eslint-disable-next-line no-console
                console.log(data.current);
                setDefaultPage(data.current);
              }}
            />
          </div>
        </div>
        <CustomBackdrop open={isLoading} />
      </Container>
    </HeaderTemplate>
  );
};

export default ClientSearchPage;
